import { PROPERTY_REQUEST_CHAT } from "./actions";

const initialState = {
  chat: [],
  chatLoading: true,
};

const propertyRequestChatReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case PROPERTY_REQUEST_CHAT:
      return {
        ...state,
        chat: payload,
        chatLoading: false,
      };
    default:
      return state;
  }
};

export default propertyRequestChatReducer;
